import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { UserPolices } from "constant";
import features from "features";
import usePolicy from "hooks/usePolicy";
import usePolygonHandler from "scenes/MapPage/usePolygonHandler";
import { EditPolygonParametersInterface } from "scenes/UnitsManager/interfaces";

import IconButton from "components/buttons/IconButton/IconButton";

import PencilIcon from "assets/icons/edit-pencil.svg";
import EyeCloseIcon from "assets/icons/eye-close.svg";
import EyeOpenIcon from "assets/icons/eye-open-black.svg";
import { ReactComponent as AreaIcon } from "assets/icons/square-area-black.svg";
import DeleteIcon from "assets/icons/trash.svg";

import styles from "./map-area-list-item.module.scss";

interface MapAreaListItemInterface {
  projectId: number | string;
  areaData: any;
  editUnitAction?: (data: EditPolygonParametersInterface) => void;
}

const MapAreaListItem = ({
  projectId,
  areaData,
  editUnitAction
}: MapAreaListItemInterface) => {
  const dispatch = useDispatch();
  const { onPolygonDelete } = usePolygonHandler(areaData);
  const { hasPolicy } = usePolicy();

  const onChangePolygonVisibility = useCallback(
    (areaData) => () => {
      const { id, isVisible } = areaData;

      dispatch(
        features.unitsManager.actions.setPolygonUnitVisibility({
          projectId,
          id,
          isVisible: !isVisible
        })
      );
    },
    [dispatch, projectId]
  );

  const onEditArea = useCallback(
    (data) => () => {
      editUnitAction(data);
    },
    [editUnitAction]
  );

  return (
    <div className={styles["area-list-item"]}>
      <span className={styles["area-name"]}>{areaData.name}</span>
      <div className={styles["external-area-controls-container"]}>
        <IconButton
          icon={
            <AreaIcon
              style={{
                fill: areaData.additional.fill_color,
                fillOpacity: areaData.additional.fill_transparency
              }}
            />
          }
          className={styles["color-button"]}
          alt={areaData.additional.fill_color}
          type="button"
        />
        <div className={styles["area-controls"]}>
          <IconButton
            icon={areaData.isVisible ? EyeOpenIcon : EyeCloseIcon}
            alt="eye-icon"
            className={styles["icon-button"]}
            onClick={onChangePolygonVisibility(areaData)}
          />
          <IconButton
            icon={PencilIcon}
            alt="pencil-icon"
            className={styles["icon-button"]}
            onClick={onEditArea(areaData)}
          />
          {hasPolicy(UserPolices.PROJECT_PROVIDER_UNIT_DELETE) && (
            <IconButton
              icon={DeleteIcon}
              alt="delete-icon"
              className={styles["icon-button"]}
              onClick={onPolygonDelete}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default MapAreaListItem;
